module.exports = __webpack_public_path__ + "static/img/packaging_2.e1f2550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/articles/packaging_2.jpg
// module id = 6/6p
// module chunks = 1